<template>
    <div
        class="cardShadow ppv2-bg-white ppv2-bg-opacity-5 ppv2-rounded-lg ppv2-p-4 ppv2-flex ppv2-items-center ppv2-justify-between hover:ppv2-shadow-md ppv2-transition-shadow ppv2-cursor-pointer"
        @click="handleClick"
    >
        <div class="ppv2-flex ppv2-items-center">
            <!--img :src="iconSrc" :alt="title" class="imgIndark h-[18px] w-[28px] ppv2-mr-4" /-->
            <div>
                <h3 class="ppv2-text-base poppinsSemiBold ppv2-text-black ppv2-mb-2 ppv2-mb-1">{{ title }}</h3>
                <p class="ppv2-text-xs ppv2-text-gray-500 ppv2-p-0-forced max-w-[546px]" v-html="description"></p>
            </div>
        </div>
        <div class="ppv2-flex ppv2-items-center ppv2-text-black">
            <span :class="statusClass" class="text-[13px] poppinsMedium ppv2-mr-4">
                {{ statusText }}
            </span>
            <ChevronRight :size="19" />
        </div>
    </div>
</template>

<script>
import { ChevronRight } from 'lucide-vue'

export default {
    name: 'ConfigurationInlineCard',
    components: {
        ChevronRight,
    },
    props: {
        iconSrc: {
            type: String,
            required: false,
        },
        chevronSrc: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
        description: {
            type: String,
            required: false,
        },
        statusText: {
            type: String,
            required: false,
        },
        statusColor: {
            type: String,
            default: '#f20606', // default to red like your original
        },
    },
    computed: {
        statusClass() {
            return {
                color: this.statusColor,
            }
        },
    },

    methods: {
        handleClick() {
            this.$emit('card-action', {
                id: this.id,
                title: this.title,
                description: this.description,
                iconSrc: this.iconSrc,
                chevronSrc: this.chevronSrc,
                statusText: this.statusText,
                statusColor: this.statusColor,
            })
        },
    },
}
</script>

<style scoped>
.ppv2-p-0-forced {
    margin-bottom: 0 !important;
}

.dark .imgIndark {
    background-color: #fff;
    padding: 5px;
    border-radius: 9px;
}
.cardShadow {
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.05);
}
.dark .cardShadow {
    box-shadow: 0px 4px 20px 0px rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.05);
}
</style>
